/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import Expansion from '@material-ui/core/ExpansionPanel';
import ExpansionSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {
    object, shape, string, arrayOf,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Add, Remove } from '@material-ui/icons';
import { useUIDSeed } from 'react-uid';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme) => ({
    container: {
        maxWidth: 1440,
        margin: '0 auto',
    },
    headingBlock: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 20,
        position: 'relative',
    },
    headerInnerBlock: {
        position: 'absolute',
        top: 75,
        textAlign: 'center',
        '& h1': {
            margin: 0,
            letterSpacing: 3,
        },
        '& p': {
            marginTop: 5,
        },
        '& a': {
            color: theme.palette.common?.black,
            fontWeight: 700,
            '& span': {
                marginLeft: 3,
            },
        },
    },
    buttonBlock: {
        padding: '9px 0',
        '& span': {
            margin: '5px 8px',
            padding: '8px 25px',
            display: 'inline-block',
            borderRadius: 26,
            color: theme.palette.common?.white,
            fontSize: 15,
            cursor: 'pointer',
        },
    },
    middleBlockInner: {
        padding: '15px 0',
        textAlign: 'center',
        fontWeight: 'bold',
        overflow: 'hidden',
        margin: 0,
        '&::before': {
            width: '50%',
            right: '0.5em',
            height: 0.5,
            content: '""',
            display: 'inline-block',
            position: 'relative',
            marginLeft: '-50%',
            verticalAlign: 'middle',
            backgroundColor: theme.palette.communitionSectionBg,
        },
        '&::after': {
            left: '.5em',
            width: '50%',
            height: 0.5,
            content: '""',
            display: 'inline-block',
            position: 'relative',
            marginRight: '-50%',
            verticalAlign: 'middle',
            backgroundColor: theme.palette.communitionSectionBg,
        },
    },
    middleBlock: {
        '& $accordionSummary': {
            minHeight: 0,
            '& div': {
                margin: 0,
                flexGrow: 'inherit',
            },
        },
        '& $accordion': {
            margin: 0,
            boxShadow: 'none',
        },
    },
    accordionSummary: {
        textAlign: 'center',
        fontWeight: 'bold',
        overflow: 'hidden',
        '&::before': {
            width: '50%',
            right: '0.5em',
            height: 0.5,
            content: '""',
            display: 'inline-block',
            position: 'relative',
            marginLeft: '-50%',
            verticalAlign: 'middle',
            backgroundColor: theme.palette.communitionSectionBg,
        },
        '&::after': {
            left: '.5em',
            width: '50%',
            height: 0.5,
            content: '""',
            display: 'inline-block',
            position: 'relative',
            marginRight: '-50%',
            verticalAlign: 'middle',
            backgroundColor: theme.palette.communitionSectionBg,
        },
        '& span.MuiIconButton-label': {
            background: theme.palette.colorPrimary,
            borderRadius: '50%',
            '& svg': {
                color: theme.palette.common?.white,
                width: 22,
                height: 22,
            },
        },
    },
    blockShadow: {
        boxShadow: `0px 3px 4px  ${theme.palette.imageCardBoxShadow}`,
        minHeight: 380,
        margin: '15px 10px',
        '& img': {
            width: '100%',
        },
        '& a': {
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 600,
            color: theme.palette.common?.black,
        },
    },
    linkForTitle: {
        padding: '25px 10px',
        textAlign: 'center',
        position: 'relative',
    },

    accordion: {
        '&::before': {
            display: 'none',
        },
    },

    articleTitle: {
        padding: 5,
        borderRadius: 22,
        position: 'absolute',
        fontSize: 12,
        width: 230,
        top: -18,
        left: 0,
        right: 0,
        margin: '0 auto',
    },
    bottomBanner: {
        '& img': {
            width: '100%',
        },
    },
});

// return card block
const card = (classes, article, articleBlockStyle) => (
    <> {article?.image?.url && <img src={article.image.url} alt={article?.button_link?.title} />}
        <div className={classes.linkForTitle}>
            {article?.partner?.title && <span className={classes.articleTitle} style={articleBlockStyle}>{article.partner.title}</span>}
            {article?.button_link?.title}
        </div>
    </>
);

// return Article grid
const articleGrid = (classes, article, seed) => {
    const articleBlockStyle = {
        backgroundColor: article?.partner?.partner_background_color || '#7ec0c0',
        color: article?.partner?.partner_font_color || '#FFFFFF',
    };

    return (
        <Grid key={seed(article)} item xs={4}>
            <div className={classes.blockShadow}>
                {article?.button_link?.href ?   (
                    <LinkOrATag href={article.button_link.href}>
                        {card(classes, article, articleBlockStyle)}
                    </LinkOrATag>
                ) : card(classes, article, articleBlockStyle)}
            </div>
        </Grid>
    );
};
// return Article block based on article conditon
const articleBlock = (classes, articleData, seed, firstThree = false) => articleData?.buttons?.map((article, index) => {
    if (firstThree) {
        return index <= 2 && articleGrid(classes, article, seed);
    }
    return  articleGrid(classes, article, seed);
});
// return Hero image block
const heroBlock = (classes, heroMobile) => {
    const titleStyle =  { color: heroMobile?.sub_title_font_color };
    let heroBlockStyle =  {};
    if (heroMobile?.text_and_button_alignment?.toLowerCase() === 'left') {
        heroBlockStyle =  { left: '15%' };
    } else if (heroMobile?.text_and_button_alignment?.toLowerCase() === 'right') {
        heroBlockStyle =  { right: '15%' };
    }
    return  (
        <div className={classes.headingBlock}>
            <img src={heroMobile?.image?.url} alt={heroMobile?.link?.title} />
            <div className={classes.headerInnerBlock} style={heroBlockStyle}>
                <h1>{heroMobile?.header}</h1>
                <p style={titleStyle}>{heroMobile?.sub_title}</p>
                <LinkOrATag href={heroMobile?.link?.href}>{heroMobile?.link?.title}</LinkOrATag>
            </div>
        </div>
    );
};
// Scroll to section
const scrollToBlock = (id) => {
    if (typeof document !== 'undefined' && document.getElementById(id)) {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
const  SympathyArticleBlock = ({ classes, data }) => {
    if (!data) {
        return null;
    }
    const heroImage = data?.hero_image || [];
    const articleSection = data?.article_section || [];
    const bottomBanner = data?.bottom_banner || {};
    const [expandedData, setExpand] = useState({
        isExpanded: {},
        blockKey: '',
    });
    const buttonBackgroundColor = data?.button_background_color?.color || '#7EBBC0';
    const heroMobile = heroImage?.find((hero) => hero?.name === 'Hero Desktop');
    const { isExpanded } = expandedData;
    const seed = useUIDSeed();
    return (
        <div className={classes.container}>
            {heroMobile && heroBlock(classes, heroMobile)}
            <div
                className={classes.buttonBlock}
            >
                {articleSection?.map((article) => (<span role="presentation" onClick={() => scrollToBlock(article?.title)} style={{ backgroundColor: buttonBackgroundColor }} key={seed(article)}>{article?.title}</span>))}
            </div>
            <div className={classes.middleBlock}>
                {articleSection?.map((article, key) => (
                    <div id={article?.title} key={seed(article)}>
                        {article?.buttons?.length > 3
                            ? (
                                <Expansion className={classes.accordion}>
                                    <ExpansionSummary
                                        expandIcon={!isExpanded[`panel_${key}`]  ? <Add />  : <Remove />}
                                        className={classes.accordionSummary}
                                        aria-controls={`${key}panel-content`}
                                        id={`${key}panel-header`}
                                        onClick={() => {
                                            const expandPanel = isExpanded;
                                            expandPanel[`panel_${key}`] = !isExpanded[`panel_${key}`];
                                            setExpand({ isExpanded: expandPanel,  blockKey: key });
                                        }}
                                    >
                                        <Typography>{article?.title}</Typography>
                                    </ExpansionSummary>
                                    <ExpansionDetails>
                                        <Grid container>{articleBlock(classes, article, seed)} </Grid>
                                    </ExpansionDetails>
                                </Expansion>
                            )
                            : <p className={classes.middleBlockInner}>{article?.title}</p> }
                        {!isExpanded[`panel_${key}`] && <Grid container>{articleBlock(classes, article, seed, true)} </Grid>}
                    </div>
                ))}
            </div>
            <Grid container className={classes.bottomBanner}>
                {bottomBanner?.link?.href
                    ? (
                        <LinkOrATag href={bottomBanner.link.href}>
                            <img src={bottomBanner?.image?.url} alt={bottomBanner?.name} />
                        </LinkOrATag>
                    )
                    : <img src={bottomBanner?.image?.url} alt={bottomBanner?.name} />}
            </Grid>
        </div>
    );
};
SympathyArticleBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        title: string.isRequired,
        title_font_color: string.isRequired,
        sub_title: string.isRequired,
        sub_title_font_color: string.isRequired,
        main_button: arrayOf(shape({
            background_color: string.isRequired,
            font_color: string.isRequired,
            link: shape({
                href: string.isRequired,
                title: string.isRequired,
            }),
        })).isRequired,
        hero_image: arrayOf(shape({
            image: shape({
                url: string.isRequired,
            }),
            link: shape({
                href: string.isRequired,
            }),
        })).isRequired,
        article_section: arrayOf(
            shape({
                title: string.isRequired,
                image: shape({
                    url: string.isRequired,
                }),
                buttons: arrayOf(
                    shape({
                        value: shape({
                            button_background_color: string.isRequired,
                            button_font_color: string.isRequired,
                            copy: string.isRequired,
                            button_link: shape({
                                href: string.isRequired,
                                title: string.isRequired,
                            }),
                        }),
                    }),
                ),
            }),
        ).isRequired,
    }).isRequired,
};

export default withStyles(styles)(SympathyArticleBlock);
